<script lang="ts" setup>
import { getCmsImage } from '@/composables/useCms';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';

interface BrandLogo {
  title?: string;
  logo?: { url?: string }[];
}

defineProps<{
  title?: string;
  brandLogo?: BrandLogo[];
}>();
</script>

<template>
  <div class="py-8">
    <VContainer>
      <h2 v-if="title" class="text-2xl lg:text-3xl 2xl:text-4xl mb-6 font-bold text-gray-900">
        {{ title }}
      </h2>

      <Swiper
        v-if="brandLogo?.length"
        :modules="[Autoplay]"
        :slides-per-view="2"
        :space-between="24"
        :loop="brandLogo.length > 4"
        :autoplay="{ delay: 2500, disableOnInteraction: false }"
        :breakpoints="{
          640: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
          1280: { slidesPerView: 6 }
        }"
      >
        <SwiperSlide v-for="(logo, index) in brandLogo" :key="`brand-logo-${index}`">
          <div class="flex h-24 items-center justify-center px-4">
            <NuxtImg
              v-if="logo.logo?.length"
              :src="getCmsImage(logo.logo)"
              :alt="logo.title || title || 'Brand logo'"
              :title="logo.title || title || 'Brand logo'"
              class="max-h-14 w-auto object-contain"
              loading="lazy"
              format="webp"
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </VContainer>
  </div>
</template>
